import '../globals';

;(function ($, _, document, globalUrls) {
    'use strict';

    var pluginName = 'categoryTree';

    function Plugin(element) {
        this.element = $(element);
        this._name = pluginName;
        this.requestArguments = $.fn.requestArguments();
        this.categoryIdentifier = '';
        this.isFilter = false;
        this.distinctField = 'productSku';
        this.fulltextSearchType = 'exact';
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        /**
         * Init
         */
        init: function () {
            if (this.element.hasClass('filter')) {
                this.isFilter = true;
                this.addClickListener();
            } else {
                this.requestArguments.addArgument('filter.category', $('.category-page').data('category'));
            }

            this.scrollTo = this.element.data('scroll-to');
            if (this.scrollTo) {
                this.requestArguments.setFragment(this.scrollTo);
            }

            this.fulltextSearchType = this.element.data('fulltext-search-type');
            this.loadTree();
        },

        /**
         * Add click listen on filter page
         */
        addClickListener: function() {
            var that = this;

            that.element.on('click touchend', 'a[data-identifier]', function(e) {
                e.preventDefault();

                that.requestArguments.addArgument('filter.category', $(this).data('identifier'));
                that.requestArguments.addArgument('fulltextsearchtype', $(this).data('fulltext-search-type'));
                that.requestArguments.redirectToArguments();

                return false;
            });
        },

        /**
         * Load category tree
         */
        loadTree: function() {
            var that = this;

            $.ajax({
                url: globalUrls.searchFilterLink,
                data: {
                    filterType: 'categoryTree',
                    fulltextSearchType: that.fulltextSearchType,
                    searchTerm: that.requestArguments.getArgument('searchterm'),
                    filters: that.requestArguments.getArgument('filter'),
                    distinctField: that.distinctField,
                    productTaggingNode: that.element.data('product-tagging-node')
                }
            }).done(function (data) {
                data = $(data);
                if (!that.isFilter) {
                    if (data.find('.active-navitem').length > 0) {
                        $('.category-page-content .category-title').text(data.find('.active-navitem').last().children('a').text());
                    }
                    $('.category-tree-fix').removeClass('hidden');
                } else {
                    data.find('[data-count]').each(function() {
                        if ($(this).data('count') <= 0) {
                            $(this).remove();
                        }
                    });
                }
                that.element.html(data.html());
            });
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            }
        });
    };
})(jQuery, _, document, globalUrls);
